// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3E1IG","left":"StickyBox_left__3u9rs","right":"StickyBox_right__NT26-"};